import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import classOfService from 'constants/propTypes/classOfService';

import { Text } from '../../JourneyDigest.styles';

const TravelInfo = ({ departureTime, arrivalTime, origin, destination, direction, fareName, classOfService, isBookingMice }) => {
  const history = useHistory();
  const isMiceGroupBooking = isBookingMice || new URLSearchParams(history.location.search).get('miceGroupBooking');

  return (
    <div className="travel-info" data-cy={`journey-${direction}`}>
      <table>
        <tbody>
          <tr>
            <td>
              <FormattedMessage id="journeySummary.dept" />:
            </td>
            <td data-id="departure-info" data-testid="table-values">
              {departureTime}{' '}
              <Text title={origin.name} underline>
                {origin.shortCode}
              </Text>
            </td>
          </tr>

          <tr>
            <td>
              <FormattedMessage id="journeySummary.arrive" />:
            </td>
            <td data-id="arrival-info" data-testid="table-values">
              {arrivalTime}{' '}
              <Text title={destination.name} underline>
                {destination.shortCode}
              </Text>
            </td>
          </tr>

          <tr>
            <td>
              <FormattedMessage id="journeySummary.class" />:
            </td>
            <td data-id="class-of-accomodation" data-testid="table-values">
              {classOfService?.name || '-'}
            </td>
          </tr>

          <tr>
            <td>
              <FormattedMessage id="journeySummary.fare" />:
            </td>
            <td data-id="fare-name" data-testid="table-values">
              {fareName}
              {isMiceGroupBooking ? ' (Mice Group)' : ''}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

TravelInfo.propTypes = {
  departureTime: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  arrivalTime: PropTypes.string,
  origin: PropTypes.shape({
    shortCode: PropTypes.string,
    name: PropTypes.string
  }),
  destination: PropTypes.shape({
    shortCode: PropTypes.string,
    name: PropTypes.string
  }),
  direction: PropTypes.string,
  fareName: PropTypes.string,
  classOfService: classOfService,
  serviceType: PropTypes.string,
  isBookingMice: PropTypes.bool
};

export default TravelInfo;
